import { FieldRenderer } from '../forms/FieldRenderer'
import { ThumbCarousel } from './ThumbCarousel'
import { RichTextV2 } from './RichTextV2'
import { ImagePanel } from './ImagePanel'
import { VideoPanel } from './VideoPanel'
import {
  V2ColorField, V2NumberField, V2SegmentedField, V2SelectField, V2SkinField, V2SliderField, V2StyleField, V2TextField,
  V2Toggle, isColourTokenField, isStyleTileField,
} from './V2Fields'
import { matchesCondition, visibleOptions } from '../../utils/conditions'
import { sliderElementLimitReached } from '../../utils/sliderValidation'
import { offeredOptions } from '../../utils/uiLayoutV2'

/**
 * One field in the Figma look, chosen by `ui.control` first and the field type second.
 * Anything without a Figma control falls back to the historical FieldRenderer component,
 * so a template can declare a type this renderer has no design for without breaking.
 */
export function V2FieldControl(props) {
  const { field, configuration, item = null, value } = props
  if (!matchesCondition(field.visibleWhen, configuration, item)) return null
  const control = field.ui?.control
  const options = offeredOptions(field, visibleOptions(field.options, configuration, item), value)
  const disabled = props.disabled || sliderElementLimitReached(configuration, props.path)
  const common = { ...props, options, disabled }

  if (control === 'thumbnail-grid') return <ThumbCarousel {...common} />
  if (control === 'percentage-slider') return <V2SliderField {...common} />
  if (control === 'image-picker' || field.type === 'image-editor') return <ImagePanel {...common} />
  if (control === 'video-picker' || field.type === 'video-editor') return <VideoPanel {...common} />
  switch (field.type) {
    case 'text':
    case 'url':
    case 'email':
    case 'tel':
      return <V2TextField {...common} />
    case 'select':
      if (isColourTokenField(field)) return <V2SkinField {...common} />
      return isStyleTileField(field) ? <V2StyleField {...common} /> : <V2SelectField {...common} />
    case 'segmented':
      return <V2SegmentedField {...common} />
    case 'boolean':
      return <V2Toggle {...common} />
    case 'color':
      return <V2ColorField {...common} />
    case 'range':
    case 'integer':
    case 'number':
    case 'duration':
      return <V2NumberField {...common} />
    case 'rich-text':
      return <RichTextV2 {...common} />
    default:
      return (
        <FieldRenderer
          field={field}
          basePath={props.path && props.path !== field.path && props.path.endsWith(`.${field.path}`)
            ? props.path.slice(0, -(field.path.length + 1)) : ''}
          templateManifest={props.templateManifest}
          configuration={configuration}
          item={item}
          error={props.error}
          onChange={(_, next) => props.onChange(next)}
          addAsset={props.addAsset}
          addRenditionPreview={props.addRenditionPreview}
          assetUrls={props.assetUrls}
          assetSourceUrls={props.assetSourceUrls}
        />
      )
  }
}
